//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Checkbox from '../checkbox/index.vue';

export default {
  name: 'SelectOption',
  components: {
    Checkbox,
  },
  props: {
    menuScope: {
      type: Object,
      default: () => {},
    },
    option: {
      type: [String, Object],
      default: null,
    },
    selectValue: {
      type: [Array, String, Object],
      default: null,
    },
    selectMultiple: {
      type: Boolean,
      default: false,
    },
    selectIsObjectOptions: {
      type: Boolean,
      default: false,
    },
    valueName: {
      default: 'value',
      type: String,
    },
    labelName: {
      default: 'label',
      type: String,
    },
    /**
     * isVisibleOption необходим для того, чтобы получить option
     * из массива options в BaseSelect, но при этом не показывать его
     * в списке
     */
    isVisibleOption: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    selected() {
      if (!this.selectValue) return false;
      if (this.selectMultiple) {
        if (this.selectValue.length === 0) return false;
        if (this.selectIsObjectOptions) {
          return this.selectValue.findIndex(i => i[this.valueName] === this.option[this.valueName]) !== -1;
        } else {
          return this.selectValue.includes(this.option);
        }
      } else {
        if (this.selectIsObjectOptions) {
          return this.selectValue[this.valueName] === this.option[this.valueName];
        } else {
          return this.selectValue === this.option;
        }
      }
    },
  },
  methods: {
    select() {
      this.$emit('select', { menuScope: this.menuScope, option: this.option });
    },
  },
};
